import { usePortfolioPerformanceTimeseries } from '@/hooks/portfolio/usePortfolioPerformanceTimeseries';
import { useUtcOffsetPeriodMap } from '../hooks';

import type { PerformancePeriod } from '../types';

import { Chart } from './Chart';

type Props = {
  market: string;
  period: PerformancePeriod;
  portfolioId: string;
  isAnalysisRestricted?: boolean;
};

/**
 * @deprecated
 * This component is deprecated.
 * The new component is `PortfolioPerformanceChart` from `@/components/PortfolioPerformanceChart`.
 * The rollout will be controlled by the `mono-portfolio-benchmark-market-selection` flag.
 */
export const PortfolioPerformanceChart = ({
  market,
  period,
  portfolioId,
  isAnalysisRestricted,
}: Props) => {
  const periodMap = useUtcOffsetPeriodMap();

  const startTimestamp = periodMap[period];
  const endTimestamp = periodMap.NOW;

  const { data, status } = usePortfolioPerformanceTimeseries({
    portfolioId,
    startTimestamp,
    endTimestamp,
  });

  return (
    <Chart
      isChartRestricted={isAnalysisRestricted}
      startTimestamp={startTimestamp}
      endTimestamp={endTimestamp}
      timeseriesStatus={status}
      market={market}
      period={period}
      timeseries={data}
    />
  );
};
